
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module attaché aux dropdown pour lesquels les valeurs des options du select sont des URLs internes vers lesquels naviguer.
 */
export default class FF_Page_Navigation_Dropdown extends FF_Module {
  init() {
    $(this.elements.container).on('change', () => {
      const url = $(this.elements.container).val();
      const url_obj = new URL(url);
      if (url_obj) {
        barba.go(url, this.elements.container);
      }
    });
  }
}
